import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const CaseSensitive: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm3 15 4-8 4 8' }],
    ['path', { d: 'M4 13h6' }],
    ['circle', { cx: '18', cy: '12', r: '3' }],
    ['path', { d: 'M21 9v6' }],
  ],
];

export default CaseSensitive;
